"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailAddressWithTLD = exports["default"] = exports.EmailAddress = exports.EMAIL_ADDRESS_REGEX_WITH_TLD = exports.EMAIL_ADDRESS_REGEX = void 0;

var _graphql = require("graphql");

var _error = require("graphql/error");

var _language = require("graphql/language");

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EMAIL_ADDRESS_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/; // copied from https://stackoverflow.com/a/201378/671457
// eslint-disable-next-line

exports.EMAIL_ADDRESS_REGEX = EMAIL_ADDRESS_REGEX;
var EMAIL_ADDRESS_REGEX_WITH_TLD = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
exports.EMAIL_ADDRESS_REGEX_WITH_TLD = EMAIL_ADDRESS_REGEX_WITH_TLD;

var makeScalar = function makeScalar(regex, opts) {
  return new _graphql.GraphQLScalarType(_objectSpread2({
    serialize: function serialize(value) {
      if (typeof value !== 'string') {
        throw new TypeError("Value is not string: ".concat(value));
      }

      if (!regex.test(value)) {
        throw new TypeError("Value is not a valid email address: ".concat(value));
      }

      return value;
    },
    parseValue: function parseValue(value) {
      if (typeof value !== 'string') {
        throw new TypeError('Value is not string');
      }

      if (!regex.test(value)) {
        throw new TypeError("Value is not a valid email address: ".concat(value));
      }

      return value;
    },
    parseLiteral: function parseLiteral(ast) {
      if (ast.kind !== _language.Kind.STRING) {
        throw new _error.GraphQLError("Can only validate strings as email addresses but got a: ".concat(ast.kind));
      }

      if (!regex.test(ast.value)) {
        throw new TypeError("Value is not a valid email address: ".concat(ast.value));
      }

      return ast.value;
    }
  }, opts));
};

var EmailAddress = makeScalar(EMAIL_ADDRESS_REGEX, {
  name: 'EmailAddress',
  description: 'A field whose value should conform to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/.'
});
exports.EmailAddress = EmailAddress;
var _default = EmailAddress;
exports["default"] = _default;
var EmailAddressWithTLD = makeScalar(EMAIL_ADDRESS_REGEX_WITH_TLD, {
  name: 'EmailAddressWithTLD',
  description: 'A field whose value should conform to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/ with a Top level domain. Valid RFC822 addresses with local domains are invalid with this scalar'
});
exports.EmailAddressWithTLD = EmailAddressWithTLD;